
import { computed, defineComponent, PropType } from 'vue'

import { PAYMENT_METHOD_OPTIONS, PAYMENT_METHOD_OPTIONS_RECEIVER_CITY_TYPE, PAYMENT_METHOD_WITHOUT_CASH, PAYMENT_METHOD_WITHOUT_KASPI } from '@/core/constants/common.constants'
import { OptionT } from '@/core/types/common.types'

export default defineComponent({
    props: {
        value: {
            type: [Number, null] as PropType<number | null>,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledOptionsValues: {
            type: Array as PropType<number[]>,
            default: () => []
        },
        receiverCityType: {
            type: Number,
            default: null
        },
        paymentType: {
            type: Number,
            default: null
        },
        isCashEnabledBySetting: {
            type: Boolean,
            default: false,
        },
        isKaspiEnabledBySetting: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isOptionSelected = (option: OptionT<number>) => {
            return option.value === props.value
        }

        const onOptionSelect = (option: OptionT<number>) => {
            if (props.disabled) return
            if (isOptionSelected(option)) return

            emit('update:value', option.value)
            emit('change', option.value)
        }

        const isOptionDisabled = (option: OptionT<number>) => {
            return props.disabledOptionsValues.includes(option.value)
        }

        const paymentOptions = computed(() => {
            if (props.paymentType === 1) {
                return PAYMENT_METHOD_OPTIONS.filter((p) => p.value === 3)
            }

            if (props.receiverCityType) {
                if (props.receiverCityType === 3) {
                    if (props.paymentType === 2) {
                        if (props.isCashEnabledBySetting && props.isKaspiEnabledBySetting) {
                            return PAYMENT_METHOD_OPTIONS
                        }

                        if (props.isCashEnabledBySetting && !props.isKaspiEnabledBySetting) {
                            return PAYMENT_METHOD_WITHOUT_KASPI
                        }

                        if (!props.isCashEnabledBySetting && props.isKaspiEnabledBySetting) {
                            return PAYMENT_METHOD_WITHOUT_CASH
                        }

                        return PAYMENT_METHOD_OPTIONS_RECEIVER_CITY_TYPE.filter((t) => t.value !== 4)
                    } else {
                        return PAYMENT_METHOD_OPTIONS_RECEIVER_CITY_TYPE
                    }
                }
            }

            return PAYMENT_METHOD_OPTIONS
        })

        return {
            isOptionSelected,
            isOptionDisabled,
            onOptionSelect,
            paymentOptions
        }
    }
})
